var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-page-not-found',{staticClass:"va-page-not-found-large-text"},[_c('div',{staticClass:"va-page-not-found-large-text__number",attrs:{"slot":"image"},slot:"image"},[_vm._v("404")])])}
var staticRenderFns = []

export { render, staticRenderFns }